import React, { Suspense } from "react";
import { GlobalState } from "./common/providers/GlobalState";
import { ThemeProviders } from "./common/providers/ThemeProvider";
import { BrowserRouter as Router, Route } from "react-router-dom";
// import MessengerCustomerChat from "react-messenger-customer-chat";

import "./common/providers/i18n";
import { Layout } from "./common/layout";

const App = () => {
  return (
    <GlobalState>
      <Suspense fallback={null}>
        <ThemeProviders>
          <Router basename={'/Menu'}>
            <Route path="/" name="Home" component={Layout} />
          </Router>
        </ThemeProviders>
      </Suspense>
      {/* <MessengerCustomerChat pageId="123651671022402" appId="2896958067216242" /> */}
    </GlobalState>
  );
};

export default App;
